module.exports = __webpack_public_path__ + "img/xiezhen.ee42c285.jpg";